<template>
  <list-items :suppress="1" />
</template>

<script>
import ListItems from '@/modules/audiences/pages/BaseListItems'
export default {
  components: { ListItems }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/pages/SuppressionListItems.vue